exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  font-size: 16px;\n  position: relative;\n  min-height: 100%; }\n\nhtml, body {\n  margin: 0;\n  padding: 0; }\n\nbody {\n  font-family: 'Roboto', sans-serif !important;\n  background-color: #f6f2f7 !important;\n  color: #47464f;\n  height: 100vh;\n  overflow: hidden; }\n", ""]);

// exports
